import { useState, useContext, useEffect } from 'react';
import AuthContext from '../store/auth-context';
import PermissionContext from '../store/permission-context';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Topbar from '../common/Topbar/Topbar';
import Sidebar from '../common/Sidebar/Sidebar';
import EntityConstants from '../configs/EntityConstants';
import { get } from '../services/FetchHelper';

import GoLoader from '../common/GoLoader/GoLoader';
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

const DashboardLayout = () => {
  const authContext = useContext(AuthContext);
  const permissionContext = useContext(PermissionContext);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarOpen = () => {
    setIsSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        const response = await get(EntityConstants.CURRENT_USER);
        if (response.ok) {
          const data = await response.json();
          permissionContext.setPermissions(data.permissions)
          authContext.login();
        } else {
          authContext.logout();
        }
      } catch (error) {
        authContext.logout();
      }
    };
    getCurrentUser();
  }, []);

  return (
    <div>
      {authContext.isLoggedIn && permissionContext.permissions.length > 0 && <GoLoader />}
      {authContext.isLoggedIn && permissionContext.permissions.length > 0 &&
        <StyledRoot>
          <Topbar isOpen={isSidebarOpen} setIsOpen={handleSidebarOpen} />
          <Sidebar open={isSidebarOpen} onClose={handleSidebarClose} />
          <Main>
            <Outlet />
          </Main>
        </StyledRoot>
      }
    </div>
  );
}
export default DashboardLayout;